export default __webpack_public_path__ + "1433d3342a9bd6d90f9e65bd4606e1c7.svg";